import { Tween } from '@tweenjs/tween.js';

export const animate = (tween: Tween) => {
	tween.update(document.timeline.currentTime as number);

	return setInterval(() => {
		tween.update(document.timeline.currentTime as number);
	}, 1000 / 60);
};
